import Marquee from "react-fast-marquee";
import { Instagram, Mail } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const f = t.footer;
  const year = new Date().getFullYear();

  const navLinks = [
    { l: t.nav.home, h: "#home" },
    { l: t.nav.agency, h: "#agence" },
    { l: t.nav.services, h: "#services" },
    { l: t.nav.players, h: "#joueurs" },
    { l: t.nav.contact, h: "#contact" },
  ];

  return (
    <footer className="bg-white text-black border-t border-black" data-testid="footer">
      <div className="border-b border-black overflow-hidden py-4">
        <Marquee speed={40} gradient={false} autoFill>
          <span className="font-display font-black uppercase text-sm md:text-lg tracking-tight px-5 text-black">
            {f.marquee}
          </span>
          <span className="text-xs md:text-sm px-1 text-black/50">✦</span>
        </Marquee>
      </div>

      <div className="mx-auto max-w-[1600px] px-5 md:px-10 pt-16 md:pt-24 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <a
              href="#home"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#home")?.scrollIntoView({ behavior: "smooth" });
              }}
              data-testid="footer-logo"
              className="inline-block"
            >
              <img
                src="/logo.png"
                alt="HM Sport Consulting"
                className="h-20 md:h-28 w-auto object-contain"
              />
            </a>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-neutral-500 mb-4">
                {f.navTitle}
              </div>
              <ul className="space-y-3">
                {navLinks.map((x) => (
                  <li key={x.h}>
                    <a
                      href={x.h}
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(x.h)?.scrollIntoView({ behavior: "smooth" });
                      }}
                      className="text-neutral-700 hover:text-black transition-colors"
                    >
                      {x.l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="text-xs uppercase tracking-[0.2em] font-bold text-neutral-500 mb-4">
                {f.contactTitle}
              </div>
              <ul className="space-y-4">
                <li>
                  <a
                    href="mailto:hmbestsportsconsulting@gmail.com"
                    data-testid="footer-email"
                    className="flex items-center gap-2 text-neutral-700 hover:text-black transition-colors break-all"
                  >
                    <Mail size={16} /> {f.emailLabel}
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/hmsportconsulting"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram"
                    className="flex items-center gap-2 text-neutral-700 hover:text-black transition-colors"
                  >
                    <Instagram size={16} /> @hmsportconsulting
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-black flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.15em] text-neutral-500">
          <span>© {year} HM Sport Consulting. {f.rights}</span>
          <span>{f.tagline}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
